(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/views/nav-big-loader.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/views/nav-big-loader.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.navbig=_svs.statistics.navbig||{};
_svs.statistics.navbig.templates=_svs.statistics.navbig.templates||{};
svs.statistics.navbig.templates.nav_big_loader = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"nav-big-loader loader loader-width loader-margin-top\"></div>";
},"useData":true});
Handlebars.partials['components-statistics-navbig-nav_big_loader'] = svs.statistics.navbig.templates.nav_big_loader;
})(svs, Handlebars);

 })(window);